/**
 * UI Preferences Storage Domain
 * Manages UI state persistence (theme, sidebar state, etc.)
 * @module @services/storage
 */

import type { UIPrefs } from '@shared/types';
import { createStorageConfig, STORAGE_KEYS } from './storage-config';

const { key: STORAGE_KEY, adapter } = createStorageConfig(STORAGE_KEYS.UI_PREFS);

const DEFAULT_PREFS: UIPrefs = {
  sidebarCollapsed: false,
  theme: 'light',
};

/**
 * Get UI preferences
 */
export function getUIPrefs(): UIPrefs {
  return adapter.getItem(STORAGE_KEY, DEFAULT_PREFS);
}

/**
 * Set UI preferences (overwrites)
 */
export function setUIPrefs(prefs: UIPrefs): void {
  adapter.setItem(STORAGE_KEY, prefs);
}

/**
 * Update UI preferences (partial)
 */
export function updateUIPrefs(updates: Partial<UIPrefs>): void {
  const prefs = getUIPrefs();
  setUIPrefs({ ...prefs, ...updates });
}
